var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_1486_5677)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.314941 12.067C0.314941 18.033 4.64794 22.994 10.3149 24V15.333H7.31494V12H10.3149V9.333C10.3149 6.333 12.2479 4.667 14.9819 4.667C15.8479 4.667 16.7819 4.8 17.6479 4.933V8H16.1149C14.6479 8 14.3149 8.733 14.3149 9.667V12H17.5149L16.9819 15.333H14.3149V24C19.9819 22.994 24.3149 18.034 24.3149 12.067C24.3149 5.43 18.9149 0 12.3149 0C5.71494 0 0.314941 5.43 0.314941 12.067Z","fill":"#DCDFEC"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_1486_5677"},React.createElement("rect",{"width":"24","height":"24","fill":"white","transform":"translate(0.314941)"})))]);
}

Facebook.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
